<div class="link-file-list-wrapper"
     *ngIf="upload !== UPLOAD_NON_VISIBLE">
    <div class="link-file-list-title">
        <sync-breadcrumb
            *ngIf="!isLoading"
            [items]="breadcrumbItems"
            (onBack)="changeDir(cwd.pid)"
            [showBackButton]="!isRoot"
        ></sync-breadcrumb>
    </div>
    <div class="link-file-list">
      <ng-container *ngIf="fileList.length > 0; else loadingOrEmpty">
        <sync-data-list [columns]="fileListColumns" [data]="dataSource" [isSelectable]="false" [allData]="fileList"
                        [trackByFn]="trackByFn"
                        sortedColumnKey="name"
                        [onRowDoubleClick]="onRowDoubleClick"
                        [isLoading]="isLoading"
                        [countText]="countText"
                        listViewBreakpoint="905px"
                        [isStickyHeader]="true"
                        [minusHeight]="235"
                        enableVirtualization="scrollContainer"
                        [lazyLoadingPaginationConfig]="lazyLoadingPaginationConfig"
                        [bottomLoadMessageTemplate]="bottomLoadMessageTemplate"
                        [listViewBreakpoint]="$any(0)"
        >
        </sync-data-list>
      </ng-container>
      <ng-template #loadingOrEmpty>
        <div class="empty-message-container" *ngIf="fileList.length === 0 && !isLoading && upload !== UPLOAD_NON_VISIBLE">
          <div class="empty-message body-1">
            No files are available.
          </div>
        </div>
      </ng-template>
    </div>
</div>

<ng-template #bottomLoadMessageTemplate>
    <div *ngIf="dataSource.length > itemPerPage && dataSource.length === fileList.length" class="loaded-all">
        <div class="caption">Loaded all {{ fileList.length }} items</div>
    </div>
</ng-template>

<div
    *ngIf="upload === UPLOAD_NON_VISIBLE"
    class="link-file-list-hidden">
    <div class="h3">This folder has been set to private.</div>
    <div class="body-1">Files uploaded to this folder cannot be viewed at this link.</div>
    <div class="upload-container">
        <app-upload-files [onUpload]="onUpload" [isPublicUpload]="true"></app-upload-files>
    </div>
</div>

<ng-template #cellTemplate let-data="data">
    <div class="display-grid" [class.droppable-folder]="data.type === 'dir'">
        <div class="ellipses">
            <a *ngIf="data.type === 'dir'" (click)="changeDir(data.sync_id)">
                {{ data["name"] || "-" }}
            </a>
            <a *ngIf="data.type !== 'dir'" (click)="$event.stopPropagation(); handlePreviewFile(data)">
                {{ data["name"] || "-" }}
            </a>
        </div>
    </div>
</ng-template>

<ng-template #iconTemplate let-data="data">
    <sync-icon *ngIf="!data[showImageKey]" [name]="getFileIcon(data)"/>
    <img class="row-thumb" *ngIf="data[showImageKey]" [src]="data[showImageKey]"/>
</ng-template>

<app-dialog-upload [(showDialog)]="openUploadDialog" [isPublicUpload]="true"></app-dialog-upload>
<app-transfer *ngIf="transferService.showTransferWindow"
              [showFilter]="!!upload"
              (openFolder)="openFolder($event)" 
              (previewFile)="handlePreviewFile($event)"
              ></app-transfer>
